<template>
  <DragPanel
    title="矢量设置"
    :closePanel="closePanel"
    :tooltipVisible="false"
    ref="dom">
    <div class="tip-content-box dialog-tip">
      <span class="tips-text">
        注：修改矢量切片精度后需重新转换才可生效，请耐心等待
      </span>
    </div>
    <div
      class="loading-box"
      v-if="isLoading">
      <Spin
        :pointNum="8"
        :translateX="25"
        background="var(--base-primary-bgColor)" />
    </div>
    <div
      v-else
      class="vector-setting-box">
      <div class="item-box clear-margin">
        <div class="label-box dialog-label">应用方式：</div>
        <div class="common-select-box">
          <el-select
            class="primary-select"
            size="small"
            v-model="isDighole"
            :popper-append-to-body="false"
            @change="setPanelStyle">
            <el-option
              :value="false"
              label="场景展示" />
            <el-option
              v-if="isShowDighole()"
              :value="true"
              label="挖洞" />
          </el-select>
        </div>
      </div>
      <div
        class="item-box"
        v-if="!isDighole">
        <div class="label-box dialog-label">贴地展示：</div>
        <div class="common-switch-box">
          <el-switch
            v-model="isTouchDown"
            class="switch-primary" />
        </div>
      </div>
      <div v-if="!isDighole">
        <div class="item-box">
          <div class="label-box">
            <div class="label dialog-label">矢量切片精度</div>
            <el-tooltip
              :effect="$theme.tooltipKey()"
              placement="top-start"
              popper-class="common-panel-tooltip-box">
              <div slot="content">
                根据矢量的覆盖范围计算得到的划分级别，该值越大，切分的矢量瓦片颗粒越精细，但是转换过程会更耗时，系统缺省值是较为平衡的方案，除非精度明显不足，否则不建议调整此值。
              </div>
              <div class="icon-box">
                <icon-svg
                  icon-class="ic-jieshishuoming"
                  class="icon" />：
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="common-slider-box">
          <el-slider
            class="slider-primary"
            input-size="mini"
            v-model="currVectorLod"
            :min="0"
            :max="maxLod"
            :step="1" />
        </div>

        <div class="item-box">
          <div class="label-box">
            <div class="label dialog-label">最远可见LOD</div>
            <el-tooltip
              :effect="$theme.tooltipKey()"
              placement="top-start"
              popper-class="common-panel-tooltip-box">
              <div
                slot="content"
                class="tipsColor">
                用于调整矢量在相机下降到哪个距离才可以看到，每个距离对应一个瓦片划分级别，该级别的最小值不能大于切片精度的最大值。
              </div>
              <div class="icon-box">
                <icon-svg
                  icon-class="ic-jieshishuoming"
                  class="icon" />：
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="common-slider-box">
          <el-slider
            class="slider-primary"
            input-size="mini"
            v-model="currVisibleDistance"
            :max="maxLod"
            :disabled="!(currVisibleDistance <= currVectorLod)"
            :format-tooltip="value => formatLodTooltip(value)"
            @change="handleLodChange" />
        </div>
        <div
          class="item-box"
          v-if="layerList.length">
          <div class="label-box">
            <div class="label dialog-label">显示优先级调整</div>
            <el-tooltip
              :effect="$theme.tooltipKey()"
              placement="top-start"
              popper-class="common-panel-tooltip-box">
              <div slot="content">
                注：矢量数据与二维图纸共用一套优先级排序系统，并规定所有二维图纸的显示优先级在矢量之上,
                在同一排序系统中按照加入场景的时间倒序显示，越靠后添加，优先级越高
              </div>
              <div class="icon-box">
                <icon-svg
                  icon-class="ic-jieshishuoming"
                  class="icon" />：
              </div>
            </el-tooltip>
          </div>
        </div>
        <div
          class="priority-setting-box"
          v-if="layerList.length">
          <div class="layer-list-box">
            <div
              class="layer-item-box"
              v-for="(item, index) in layerList"
              :key="index">
              <div
                class="text-overflow"
                :title="item.name">
                {{ item.name }}
              </div>
              <div class="common-button-box">
                <el-button
                  type="text"
                  size="small"
                  title="上移"
                  :disabled="index === 0"
                  @click="moveLayer(item, true)">
                  <icon-svg
                    icon-class="ic-shengxu"
                    class="icon" />
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  title="下移"
                  :disabled="index === layerList.length - 1"
                  @click="moveLayer(item, false)">
                  <icon-svg
                    icon-class="ic-jiangxu"
                    class="icon" />
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="tip-content-box dialog-label">
        当前矢量用于在场景中挖洞，最终场景中不显示该矢量数据
      </div>
    </div>
    <div class="operation-btn-box">
      <el-button
        size="small"
        @click="closePanel"
        class="normal-ang-btn gr8 hollowOut-btn">
        取消
      </el-button>
      <el-button
        size="small"
        type="primary"
        @click="submit"
        class="primary-btn primary-ang-btn">
        确定
      </el-button>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import Spin from '@/components/Spin.vue'

import {
  getSceneVectorConfigService,
  updateSceneVectorConfigService
} from '@/service/interface'

export default {
  data() {
    return {
      isLoading: false,

      originConfig: {},

      vectorFileType: '',
      isDighole: false,
      isTouchDown: true,
      currVectorLod: 0,
      currVisibleDistance: 0,
      layerList: [],

      maxLod: 0
    }
  },
  props: {
    vectorInfo: Object,
    setUnitShpHole: Function,
    updateUnitLayerLevelByLayerList: Function,
    setUnitLODLevByDataSetId: Function,
    openConvertQueue: Function,
    updateConvertDataSets: Function,
    updateSceneTreeStatus: Function,
    updateSceneTree: Function,
    closeVectorSettingPanel: Function
  },
  components: {
    DragPanel,
    Spin
  },
  mounted() {
    this.initVectorConfig().then(() => {
      this.setPanelStyle()
    })
  },
  methods: {
    initVectorConfig() {
      this.isLoading = true
      return new Promise(resolve => {
        let vectorInfo = this.vectorInfo
        let nodeId = vectorInfo.sceneNodeId
        getSceneVectorConfigService(nodeId).then(response => {
          if (response.isSuccess) {
            let data = response.data
            this.originConfig = JSON.parse(JSON.stringify(data))

            let systemLodConfig = data.systemLodConfig
            this.maxLod = Number(systemLodConfig.lodNum) - 1

            this.vectorFileType = data.vectorFileType
            this.isDighole = data.isDighole
            this.isTouchDown = data.isTouchDown
            this.currVectorLod = data.lod
            this.currVisibleDistance = data.visibleDistance
            this.layerList = data.priorityList

            this.isLoading = false
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    handleLodChange(value) {
      let vectorInfo = this.vectorInfo
      let dataSetId = vectorInfo.dataSetId
      let range = [value, this.maxLod]
      this.setUnitLODLevByDataSetId(dataSetId, range)
    },
    moveLayer(layerInfo, isUpMove) {
      let findIndex = this.layerList.findIndex(
        el => el.treeNodeId === layerInfo.treeNodeId
      )
      let elementToMove = this.layerList[findIndex]
      this.layerList.splice(findIndex, 1)

      // 再将元素插入到新的位置
      if (isUpMove) {
        this.layerList.splice(findIndex - 1, 0, elementToMove)
      } else {
        this.layerList.splice(findIndex + 1, 0, elementToMove)
      }

      this.updateUnitLayerLevelByLayerList(this.layerList)
    },
    submit() {
      let vectorInfo = this.vectorInfo
      let treeNodeId = vectorInfo.sceneNodeId
      let priorityList = this.layerList.map(el => {
        let obj = { treeNodeId: el.treeNodeId }
        return obj
      })

      let params = {
        treeNodeId,
        isDigHole: this.isDighole,
        isTouchDown: this.isDighole ? true : this.isTouchDown,
        lod: this.currVectorLod,
        visibleDistance: this.currVisibleDistance,
        priorityList
      }
      updateSceneVectorConfigService(params).then(response => {
        if (response.isSuccess) {
          this.handleConfigChange(treeNodeId).then(() => {
            this.closeVectorSettingPanel()

            this.$message.success('设置成功')
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    handleConfigChange() {
      return new Promise(resolve => {
        let originConfig = this.originConfig
        if (originConfig.lod !== this.currVectorLod) {
          this.openConvertQueue()
          this.updateSceneTreeStatus([this.vectorInfo.dataSetId])
          resolve()
          return
        }

        this.updateSceneTree().then(() => {
          if (originConfig.isDighole !== this.isDighole) {
            if (originConfig.isTouchDown) {
              this.setUnitShpHole()
            } else {
              let dataSetId = this.vectorInfo.dataSetId
              this.updateConvertDataSets([dataSetId])
            }
          }

          if (originConfig.isTouchDown !== this.isTouchDown) {
            let dataSetId = this.vectorInfo.dataSetId
            this.updateConvertDataSets([dataSetId])
          }

          resolve()
        })
      })
    },
    setPanelStyle() {
      this.$nextTick(() => {
        let domRef = this.$refs.dom.$el
        let panelHeaderDom = domRef.querySelector('.header-box')
        let panelContentDom = domRef.querySelector('.content')
        let height = panelHeaderDom.offsetHeight + panelContentDom.offsetHeight

        domRef.style.height = `${height}px`
        domRef.style.minHeight = `${height}px`
      })
    },
    isShowDighole() {
      if (this.vectorFileType && this.vectorFileType.includes('Polygon')) {
        return true
      } else {
        return false
      }
    },
    formatLodTooltip(value) {
      if (value > this.currVectorLod) {
        this.currVisibleDistance = this.currVectorLod
        return '最远可见LOD的下限不能大于矢量切片精度'
      }
    },
    closePanel() {
      let originConfig = this.originConfig
      let priorityList = originConfig.priorityList
      this.updateUnitLayerLevelByLayerList(priorityList)

      let systemLodConfig = originConfig.systemLodConfig
      let minLod = originConfig.visibleDistance
      let maxLod = Number(systemLodConfig.lodNum) - 1
      let range = [minLod, maxLod]
      let vectorInfo = this.vectorInfo
      let dataSetId = vectorInfo.dataSetId
      this.setUnitLODLevByDataSetId(dataSetId, range)

      this.closeVectorSettingPanel()
    },
    // 打开其他面板前给出提示
    openOtherPanelCheck() {
      return new Promise(resolve => {
        let message = '正在调整矢量设置，请结束后再执行相关操作'
        let options = {
          message,
          type: 'warning',
          duration: 5000,
          showClose: true
        }
        this.$message(options)
        resolve(false)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  left: 6px;
  top: 6px;
  width: 360px;
  height: unset;
  min-width: 360px;

  .tip-content-box {
    padding-top: 12px;
    margin-bottom: 0;
    padding-left: 0;
    text-align: left;

    &.dialog-tip {
      padding-left: 32px;
    }
  }
  .loading-box {
    height: 300px;
  }

  .vector-setting-box {
    padding: 15px;
    font-size: 14px;
    color: var(--default-color);

    .item-box {
      display: flex;
      align-items: center;
      margin-top: 15px;

      .label-box {
        flex-shrink: 0;
        display: flex;

        .icon-box {
          display: flex;
          align-items: center;
          margin-left: 3px;
        }

        .icon {
          margin-right: 2px;
        }
      }

      .common-select-box {
        flex-grow: 1;
        text-align: left;

        .primary-select {
          width: 100%;
        }

        // /deep/ .el-select {
        //   width: 100%;

        //   .el-input__inner {
        //     background: #1e1f1e;

        //     &:hover {
        //       border-color: var(--primary-color);
        //     }
        //   }

        //   .el-select-dropdown {
        //     margin-top: 2px;
        //     border-radius: 4px;
        //     background: #2c2c2c;
        //     box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.1),
        //       0px 8px 10px 1px rgba(0, 0, 0, 0.06),
        //       0px 3px 14px 2px rgba(0, 0, 0, 0.05);

        //     .el-select-dropdown__item {
        //       margin: 4px 8px;
        //       &.selected {
        //         background-color: var(--primary-color) !important;
        //       }

        //       &.hover {
        //         background: rgba(255, 255, 255, 0.1);
        //       }

        //       &:hover {
        //         background: rgba(255, 255, 255, 0.1);
        //       }
        //     }
        //   }
        // }
      }

      .common-switch-box {
        display: flex;

        .switch-name-box {
          margin-left: 10px;
        }
      }
    }

    .clear-margin {
      margin-top: 0px;
    }

    .common-slider-box {
      margin-top: 15px;
      padding: 3px 27px;
      border-radius: 8px;
      background: var(--scene-edit-setting-bgColor);
      border: 1px solid var(--scene-edit-setting-border-color);
    }

    .priority-setting-box {
      margin-top: 15px;
      border-radius: 8px;
      background-color: var(--scene-edit-setting-bgColor);
      border: 1px solid var(--scene-edit-setting-border-color);

      .layer-list-box {
        color: var(--default-color);
        padding: 10px;
        height: 120px;
        overflow-y: auto;

        .layer-item-box {
          display: flex;
          justify-content: space-between;
          padding: 0px 8px;
          border-radius: 4px;
          line-height: 32px;

          &:hover {
            background: var(--scene-edit-setting-item-hover-color);

            .common-button-box {
              display: block;

              .el-button--small {
                padding: 5px 0px;
              }
            }
          }

          .common-button-box {
            display: none;
            .icon {
              color: var(--icon-dark-color);
            }
          }
        }
      }
    }
  }

  .operation-btn-box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 64px;
    padding: 10px 16px;
    border-top: 1px solid var(--dialog-split-line-color);
  }
}
</style>
